module.exports = __webpack_public_path__ + "img/sp-step-4.b56ba25b.jpg";